import api from 'services/api';

/**
 * Query da conexão no socket de eventos da 3CPlus.
 * Colaborador sem ID do agente (ramal2) segue como sempre: só o token pessoal
 * (ramal), sem consultar o backend. Com ID, o backend decide: se a integração
 * tem token de serviço devolve { token, agent_id }; senão, o token pessoal.
 */
export async function querySocket3CPlus(authUserInfo) {
  const ramal = authUserInfo ? authUserInfo.ramal : '';
  if (!authUserInfo || !authUserInfo.ramal2) return { token: ramal };

  try {
    const { data } = await api.get('/pabx_3cplus_socket');
    if (!data.token) return { token: ramal };
    return data.agent_id
      ? { token: data.token, agent_id: data.agent_id }
      : { token: data.token };
  } catch (error) {
    return { token: ramal };
  }
}
